import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'fx-ib-detail',
  templateUrl: './ib-detail.component.html',
  styleUrls: ['./ib-detail.component.sass'],
})
export class IbDetailComponent implements OnInit {
  @Input() ib: any;
  data: any[] = [];
  constructor() {}

  ngOnInit(): void {}
}
